<template>
  <div v-if="isAvailable&&examinationPart&&currentPageComponent">
    <div v-if="isDebug" class="debug_str">TG1 練習Ｂ_言語＋計数 検査１</div>

    <div class="row mt-3">
      <div class="col-12">
        <ExamInternalHeader :isDebug="isDebug"
                            :examinationPart="examinationPart" :currentPageNo="currentPageNo" :canEdit="canEdit" :showDescription="showDescription"
                            @move-page="onMovePage"
        />
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12" id="examination_parts_wrapper">
        <div v-if="isDebug" class="debug_str">ページのコンポーネント（{{ currentPageComponent }}）</div>
        <keep-alive>
          <component :is="currentPageComponent" ref="refPageComponent" :isDebug="isDebug"
                      :examinationPart="examinationPart" :canEdit="canEdit" :showDescription="showDescription"
                      choiceDelimiter="." :showLongAnswer="false"
                      v-model="currentPageParams"
          />
        </keep-alive>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <ExamInternalFooter :isDebug="isDebug"
                            :canEdit="canEdit" :showDescription="showDescription"
                            :examinationPart="examinationPart" :currentPageNo="currentPageNo" :examPartRemainingSec="examPartRemainingSec"
                            :questionCount="question_count" :answeredCount="answered_count"
                            @move-page="onMovePage" @move-next-page="onMoveNextPage" @move-prev-page="onMovePrevPage"
                            @finish-exam-part="onFinishExamPart"
        />
      </div>
    </div>

  </div>
</template>

<script>
import commonMixin from '../../common_exam_part';
import ExamInternalHeader from '../../TG/ExamInternalHeader';
import ExamInternalFooter from '../../TG/ExamInternalFooter';
// ↓ 本コンポーネントは以下のコンポーネントから呼ばれる
// admin/views/master/examination_parts/Edit.vue
// student/views/Exam.vue
// student/views/Result.vue
// ↑
// ↓ 配下の全ページをimportする ※ components への記載も忘れないこと！！
// ※ ページ部(_p01など)を除くコンポーネント名は examination_parts.main_component_name に定義されている
import tg1_pb_gk_t1_p01 from './検査１/p01';
import tg1_pb_gk_t1_p02 from './検査１/p02';
import tg1_pb_gk_t1_p03 from './検査１/p03';
import tg1_pb_gk_t1_p04 from './検査１/p04';
import tg1_pb_gk_t1_p05 from './検査１/p05';
import tg1_pb_gk_t1_p06 from './検査１/p06';
import tg1_pb_gk_t1_p07 from './検査１/p07';
import tg1_pb_gk_t1_p08 from './検査１/p08';
import tg1_pb_gk_t1_p09 from './検査１/p09';
import tg1_pb_gk_t1_p10 from './検査１/p10';
import tg1_pb_gk_t1_p11 from './検査１/p11';
import tg1_pb_gk_t1_p12 from './検査１/p12';
import tg1_pb_gk_t1_p13 from './検査１/p13';
import tg1_pb_gk_t1_p14 from './検査１/p14';
import tg1_pb_gk_t1_p15 from './検査１/p15';
// ↑
const LogHeader = 'TG1/練習Ｂ_言語＋計数/検査１';

export default {
  mixins: [
    commonMixin,
  ],
  components: {
    ExamInternalHeader,
    ExamInternalFooter,
    tg1_pb_gk_t1_p01,
    tg1_pb_gk_t1_p02,
    tg1_pb_gk_t1_p03,
    tg1_pb_gk_t1_p04,
    tg1_pb_gk_t1_p05,
    tg1_pb_gk_t1_p06,
    tg1_pb_gk_t1_p07,
    tg1_pb_gk_t1_p08,
    tg1_pb_gk_t1_p09,
    tg1_pb_gk_t1_p10,
    tg1_pb_gk_t1_p11,
    tg1_pb_gk_t1_p12,
    tg1_pb_gk_t1_p13,
    tg1_pb_gk_t1_p14,
    tg1_pb_gk_t1_p15,
  },
  created() {
    console.log(`[${LogHeader}] created() CALLED`);
  },
  mounted() {
    console.log(`[${LogHeader}] mounted() CALLED`);
  },
  activated() {
    console.log(`[${LogHeader}] activated() CALLED`);
  },
  deactivated() {
    console.log(`[${LogHeader}] deactivated() CALLED`);
  },
  computed: {
  },
  methods: {
  },
};
</script>

<style lang="sass" scoped>
</style>
